import yup from "../../../../utils/yup-extended";

const discountCodeFormSchemaV2 = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required("Discount code name is required")
    .typeError("Must be a valid string"),
  offerings: yup
    .array()
    .of(yup.string().required("Select from the list of offerings"))
    .min(1, "Select at least one offering"),
  selectAllOfferings: yup.boolean(),
  percentage_off: yup
    .number()
    .required("Percentage off is required")
    .min(1, "Must be greater than or equal to 1")
    .typeError("Must be a valid number"),
  customersType: yup
    .string()
    .required("Select a customer type")
    .oneOf(["limited", "unlimited"], "Select a valid customer type"),
  usage_limit: yup.number().when("customersType", {
    is: (customersType: "unlimited" | "limited") => customersType === "unlimited",
    then: (schema) => schema.default(-1),
    otherwise: (schema) =>
      schema
        .min(1, "Can't be less than 1")
        .required("Number of customers is required")
        .typeError("Must be a number"),
  }),
  usage: yup
    .string()
    .required("Select a usage type")
    .oneOf(["one time", "multiple"], "Select a valid usage value"),
  validity: yup
    .array()
    .of(yup.string().required("Select a start date and an end date"))
    .min(1, "Validity is required"),
});

export function getDiscountCodeFormSchema() {
  return discountCodeFormSchemaV2;
}
